import { ReactElement, lazy, Suspense } from 'react';
import { Switch, Router, Route } from 'react-router-dom';

import ILazyComponent from '^types/common/ILazyComponent';
import {
  getRootPageRoutePath, getErrorRouteUrl,
} from '^utils/routingHelpers';
import sharedHistory from '^sharedHistory';
import ErrorPage from '^components/ErrorPage';
import PageSkeleton from '^components/PageSkeleton';

const Root = lazy((): Promise<ILazyComponent> => import('^pages/Root'));

const RoutingRules = (): ReactElement => (
  <Suspense fallback={<PageSkeleton />}>
    <Router history={sharedHistory}>
      <Switch>
        <Route
          component={Root}
          path={getRootPageRoutePath()}
          exact
        />

        <Route
          path={getErrorRouteUrl()}
          component={ErrorPage}
          exact
        />
      </Switch>
    </Router>
  </Suspense>
);

export default RoutingRules;
